import type { AdminViewDefinition } from "../../../components/admin-components.js";
import { storeOverviewView } from "../store-detail/store-detail-pages.js";

export const supportAdminViews: AdminViewDefinition[] = [supportSessionActiveView()];

function supportSessionActiveView(): AdminViewDefinition {
  return {
    ...storeOverviewView(),
    id: "support-session-active",
    actions: [
      {
        label: "View session activity",
        routeId: "support-session-activity",
        disabled: true,
        disabledReason: "Support session activity does not have a backend API yet.",
      },
      {
        label: "End session",
        variant: "danger",
        routeId: "end-support-session",
        disabled: true,
        disabledReason: "Ending support sessions from Admin UI is not wired yet.",
      },
    ],
  };
}
